import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollUtils';

/**
 * Enhanced ScrollToTop component that:
 * 1. Handles smooth scrolling to top on route changes
 * 2. Preserves scroll position for back/forward navigation
 * 3. Special handling for policy pages
 */
function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  const initialized = useRef(false);
  const isPolicyPage = ['/privacy', '/terms', '/cookies'].includes(pathname);

  useEffect(() => {
    // Skip the initial render
    if (!initialized.current) {
      initialized.current = true;
      return;
    }

    // Set scroll padding for fixed header
    document.documentElement.style.scrollPaddingTop = '80px';

    // Don't auto-scroll for policy pages - we'll handle that in the Footer click handler
    if (isPolicyPage) {
      return;
    }

    // Handle hash fragments
    if (hash) {
      // Delay scroll to ensure DOM is loaded
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          // Fallback to top if element not found
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 300); // Longer timeout to ensure DOM is fully rendered
    } else {
      // For regular navigation (no hash), scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash, key, isPolicyPage]);

  return null;
}

export default ScrollToTop;